import { ThemeEvents } from '@theme/events';

/**
 * Keeps server-rendered, variant-dependent CLNF PDP fragments (points box, heat/melt agreement)
 * in sync after a variant change. Horizon's variant picker already fetches the new variant's
 * HTML and passes it on the `variant:update` event, so the fresh markup is swapped in with no
 * extra request. Elements opt in with `data-clnf-variant-sync="<unique key>"`.
 */
if (!window.__clnfPdpVariantSync) {
  window.__clnfPdpVariantSync = true;

  document.addEventListener(ThemeEvents.variantUpdate, (event) => {
    const html = event.detail?.data?.html;
    if (!(html instanceof Document) || !(event.target instanceof Element)) return;

    const scope = event.target.closest('.shopify-section, dialog') ?? document;

    for (const current of scope.querySelectorAll('[data-clnf-variant-sync]')) {
      const key = current.getAttribute('data-clnf-variant-sync');
      if (!key) continue;
      const fresh = html.querySelector(`[data-clnf-variant-sync="${CSS.escape(key)}"]`);
      if (fresh) current.replaceWith(document.importNode(fresh, true));
    }
  });
}
